var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { EmptyDecoration } from "./empty-decoration";
const parseFontWeight = (fontWeight) => {
  if (fontWeight === "bold") {
    return 700;
  }
  if (fontWeight === "normal") {
    return 400;
  }
  return parseInt(fontWeight, 10);
};
class BoldDecoration {
  constructor(customStyle) {
    __publicField(this, "type", Decoration_Type.BOLD);
    __publicField(this, "customStyle");
    this.customStyle = customStyle;
  }
  static of(decoration) {
    if (decoration.type !== Decoration_Type.BOLD) {
      throw new TypeError(`invalid decoration initializer ${decoration}`);
    }
    return new BoldDecoration({ fontWeight: decoration.fontWeightValue });
  }
  getDecoration() {
    return {
      type: this.type,
      fontWeightValue: parseFontWeight(this.customStyle.fontWeight)
    };
  }
  static fromCustomStyle(customStyle) {
    return new BoldDecoration(customStyle);
  }
  fromCustomStyle(customStyle) {
    return BoldDecoration.fromCustomStyle(customStyle);
  }
  toCustomStyle() {
    return this.customStyle;
  }
  overrideWith(decoration) {
    if (!(decoration instanceof BoldDecoration || decoration instanceof EmptyDecoration)) {
      throw new TypeError(`invalid merge decoration ${decoration}`);
    }
    const customStyle = { ...this.customStyle, ...decoration.toCustomStyle() };
    return new BoldDecoration(customStyle);
  }
}
export {
  BoldDecoration
};
//# sourceMappingURL=bold-decoration.js.map
